import { Radio as AntRadio, RadioProps } from "antd";
import styled from "styled-components";

export const Radio: typeof AntRadio = styled(AntRadio)<RadioProps>``;
